import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

const rootEl = document.getElementById("root");
// El HTML publicado ya trae contenido prerenderizado: hydrate para no borrarlo ni duplicarlo.
if (rootEl.hasChildNodes()) ReactDOM.hydrateRoot(rootEl, tree);
else ReactDOM.createRoot(rootEl).render(tree);
